module.exports = __webpack_public_path__ + "static/media/turnover-rightv2.81eba42f.png";